// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fSxE","placeholdersHeader":"styles_placeholdersHeader__7PE2G","editorStyle":"styles_editorStyle__2VxBn","placeholdersBox":"styles_placeholdersBox__2HyB9"};